import { DispensaryCollectionsPage } from 'src/dispensary/collections';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { getCacheableSearchVisibilityServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getCacheableSearchVisibilityServerSideProps;

export default Object.assign(DispensaryCollectionsPage, { layout: MainDispensaryLayout });
